import e from "./ScreenReader.vue.script.js";
//#region src/shared/ScreenReader.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=ScreenReader.vue.js.map